export default __webpack_public_path__ + "static/media/profileSidebarIcon_politics.fad691e1.svg";